<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />
    <div>
      <!--    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>-->
      <b-card class="bCardLocal">
        <b-row class="divSubtitulo ml-2 mr-1">
          <b-col cols="6" md="10">
            <div>
              <p class="textoSubtitulo">Portal Socios</p>
            </div>
          </b-col>
          <b-col cols="6" md="2">
            <div>
              <p style="text-align: end" class="textoSubtitulo">
                PAS_portal_autoser
              </p>
            </div>
          </b-col>
        </b-row>

        <div
          class="d-flex justify-content-start mt-5 ml-2"
          style="min-height: 35px"
        >
          <div class="" v-for="(tab, index) in tabsPortal" :key="index">
            <div
              class="pr-5 m-0 d-flex align-items-center flex-column"
              style="height: 100%"
              @click="activeTabIndex = index"
              v-if="$localStorageService.can(tab.permiso)"
            >
              <a
                ><p
                  class="m-0 p-0"
                  :class="activeTabIndex == index ? 'selectedTab' : 'tabPortal'"
                >
                  {{ tab.title }}
                </p></a
              >
              <hr
                v-if="activeTabIndex == index"
                class="w-50 m-0 p-0 mt-3"
                style="height: 0.06em; background-color: #83bee8"
              />
            </div>
          </div>
        </div>

        <div v-if="activeTabIndex == 0">
          <div
            class="mt-5 d-flex justify-content-center"
            style="margin-top: 8% !important"
          >
            <div class="barras d-flex" style="width: 50%">
              <b-form-input
                @keydown.enter.native="obtenerDocumentosLegales()"
                class="input-filter"
                v-model="filtro.palabraClave"
                placeholder="Búsqueda de documentos por nombre"
                type="text"
              >
              </b-form-input>
              <b-button
                class="btn_busqueda"
                variant="info"
                @click="obtenerDocumentosLegales()"
              >
                <div
                  class="d-flex justify-content-center align-items-center"
                  style="height: 100%"
                >
                  <em class="buscar_svg" style="margin-top: 3px; height: 0.8em">
                  </em>
                </div>
              </b-button>
            </div>

            <b-button
              v-if="$localStorageService.can('PAS_01_portal_aut_doc_agreg')"
              variant="primary"
              v-b-tooltip.hover
              title="Agregar nuevo documento"
              class="paddingbotones botonesAzulFuerteRedondo d-flex justify-content-center align-items-center mt-4 ml-4"
              responsive
              @click="agregar()"
              ><em class="documento_svg icon-boton"></em>
            </b-button>
          </div>

          <div>
            <b-table
              :items="datosTabla"
              :fields="fields"
              :per-page="$registrosPorPaginaTabla"
              :current-page="paginaActual"
              responsive
              style="margin-top: 6%"
            >
              <template v-slot:cell(ACCIONES)="row">
                <b-button-group>
                  <b-button
                    title="Vista previa documento"
                    size="sm"
                    variant="outline-primary"
                    @click="vistaPrevia(row.item)"
                    v-if="
                      $localStorageService.can('PAS_01_portal_aut_doc_detalle')
                    "
                    ><em class="fa fa-eye"></em
                  ></b-button>
                  <b-button
                    title="Modificar documento"
                    size="sm"
                    variant="outline-warning"
                    @click="modificar(row.item)"
                    v-if="
                      $localStorageService.can('PAS_01_portal_aut_doc_edit')
                    "
                    ><em class="fa fa-pencil"></em
                  ></b-button>
                  <b-button
                    v-if="
                      !row.item.registro &&
                      $localStorageService.can('PAS_01_portal_aut_doc_inac')
                    "
                    title="Activar documento"
                    variant="outline-danger"
                    size="sm"
                    @click="activarDesactivarMotivo(row.item)"
                    ><em class="fa fa-undo"></em
                  ></b-button>
                  <b-button
                    v-else-if="
                      $localStorageService.can('PAS_01_portal_aut_doc_inac')
                    "
                    title="Desactiva documento"
                    variant="outline-danger"
                    size="sm"
                    @click="activarDesactivarMotivo(row.item)"
                  >
                    <b-icon icon="trash-fill"></b-icon>
                  </b-button>
                </b-button-group>
              </template>
            </b-table>
            <b-pagination
              v-if="datosTabla !== undefined && datosTabla.length > 10"
              align="center"
              v-model="paginaActual"
              :total-rows="datosTabla.length"
              :per-page="registrosPorPagina"
              aria-controls="my-table1"
            ></b-pagination>
          </div>
          <div
            v-if="datosTabla.length === 0"
            class="d-flex justify-content-center align-items-center"
            style="min-height: 30vh"
          >
            <p>No se encontraron resultados</p>
          </div>
        </div>

        <div v-if="activeTabIndex == 1">
          <emisionRenovacionCuentas></emisionRenovacionCuentas>
        </div>

        <div v-if="activeTabIndex == 2">
          <usuariosPortalAutoservicio></usuariosPortalAutoservicio>
        </div>

        <div v-if="activeTabIndex == 3">
          <AltaMasivaUsuario></AltaMasivaUsuario>
        </div>

        <div v-if="activeTabIndex == 4">
          <EditorCodigo :id-terminos-condiciones="18"></EditorCodigo>
        </div>
      </b-card>
    </div>

    <b-modal v-model="show" :title="tituloModal" size="lg" no-close-on-backdrop>
      <b-container fluid>
        <b-row>
          <b-col>
            <b-form>
              <b-form-group align="left">
                <label for="documento"
                  >Documento Legal
                  <validacion />
                </label>
                <b-input-group size="sm" class="mb-2">
                  <b-input-group-prepend is-text>
                    <b-icon icon="card-checklist"></b-icon>
                  </b-input-group-prepend>
                  <v-select
                    id="documento"
                    name="documento"
                    placeholder="seleccione el nombre del documento"
                    label="tipoDocumententoLegal"
                    :options="listaTipoDocumentos"
                    v-model="$v.documento.tipoDocumentoLegalDTO.$model"
                    :state="validateState('tipoDocumentoLegalDTO')"
                    :class="selectClass('tipoDocumentoLegalDTO')"
                    style="width: 95%"
                  ></v-select>
                </b-input-group>
              </b-form-group>
              <h6
                v-if="
                  documento.imagenBase64 !== '' &&
                  documento.imagenBase64 !== null &&
                  documento.imagenBase64 !== undefined
                "
                style="font-weight: bolder"
              >
                Vista Previa
              </h6>
              <h6 v-else style="font-weight: bolder">
                Seleccione un Archivo <span style="color: red">*</span>
              </h6>
              <b-row
                v-if="
                  documento.imagenBase64 !== '' &&
                  documento.imagenBase64 !== null &&
                  documento.imagenBase64 !== undefined
                "
              >
                <div id="loadImg" class="text-center">
                  <b-spinner
                    small
                    variant="primary"
                    label="Spinning"
                  ></b-spinner>
                </div>
                <iframe
                  :src="'data:application/pdf;base64,' + documento.imagenBase64"
                  width="100%"
                  height="600"
                  onload="document.getElementById('loadImg').style.display='none';"
                  style="height: 77vh"
                ></iframe>
              </b-row>
              <b-row>
                <b-col class="col-4"></b-col>
                <b-col class="mt-2">
                  <span class="btn btn-primary btn-file">
                    <span>
                      <input type="file" @change="changeArchivo($event)" />
                      <span>Subir Archivo</span>
                      <b-spinner
                        v-if="loaderArchivo"
                        small
                        variant="light"
                        label="Spinning"
                      ></b-spinner>
                    </span>
                  </span>
                </b-col>
                <b-col class="col-4"></b-col>
              </b-row>
            </b-form>
          </b-col>
        </b-row>
      </b-container>
      <div slot="modal-footer">
        <b-button
          variant="outline-primary"
          @click="guardaDocumento()"
          :disabled="loaderAcciones"
        >
          <span v-if="!loaderAcciones">Guardar</span>
          <span v-if="loaderAcciones">
            <b-spinner small></b-spinner>
            Cargando...
          </span>
        </b-button>
        <b-button
          variant="outline-danger"
          @click="cerrarModal()"
          :disabled="loaderAcciones"
          >Cancelar</b-button
        >
      </div>
    </b-modal>
    <b-modal
      v-model="showVistaPrevia"
      title="Vista Previa"
      size="lg"
      no-close-on-backdrop
    >
      <b-container fluid>
        <b-row>
          <b-col>
            <div id="loadImg" class="text-center">
              <b-spinner small variant="primary" label="Spinning"></b-spinner>
            </div>
            <iframe
              :src="'data:application/pdf;base64,' + base64Archivo"
              width="100%"
              height="600"
              onload="document.getElementById('loadImg').style.display='none';"
              style="height: 77vh"
            ></iframe>
          </b-col>
        </b-row>
      </b-container>
      <div slot="modal-footer">
        <b-button variant="outline-danger" @click="cerrarModalPrevia()"
          >Cancelar</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
import Header from "../../components/Header";
import { required } from "vuelidate/lib/validators";
import emisionRenovacionCuentas from "./emisionRenovacionCuentas.vue";
import usuariosPortalAutoservicio from "./usuariosPortalAutoservicio.vue";
import EditorCodigo from "@/views/EditorCodigo";
import AltaMasivaUsuario from "./altaMasivaUsuario";

export default {
  components: {
    EditorCodigo,
    Header,
    emisionRenovacionCuentas,
    usuariosPortalAutoservicio,
    AltaMasivaUsuario,
  },
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      tabsPortal: [
        {
          title: "Documentos legales",
          permiso: "PAS_01_portal_aut_doc_legales",
        },
        {
          title: "Documentos de emisión",
          permiso: "PAS_01_portal_aut_emisi_renova",
        },
        {
          title: "Administración de usuarios",
          permiso: "PAS_01_portal_aut_usr_portal",
        },
        {
          title: "Alta masiva usuario",
          permiso: "PAS_01_portal_aut_alta_usuario",
        },
        {
          title: "Términos y condiciones",
          permiso: "PAS_01_portal_aut_term_condi",
        },
      ],
      activeTabIndex: 0,
      loader: false,
      datosTabla: [],
      fields: [],
      paginaActual: 0,
      listaTipoDocumentos: [],
      tituloModal: "",
      loaderAcciones: false,
      loaderArchivo: false,
      show: false,
      showVistaPrevia: false,
      base64Archivo: "",
      archivoSeleccionado: null,
      hoy: null,
      documento: {
        idDoumentacionLegal: null,
        documentacion: null,
        rutaDocumentacion: null,
        tipoDocumentoLegalDTO: null,
        imagenBase64: null,
        registro: null,
      },
      filtro: {
        id: null,
        palabraClave: null,
        registroActivo: null,
      },
      registrosPorPagina: 10,
    };
  },
  validations: {
    documento: {
      tipoDocumentoLegalDTO: { required },
    },
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.hoy = this.$moment(Date.now()).format("MMMM YYYY");
    this.obtenerTipoDocumentosLegales();
    this.obtenerDocumentosLegales();
  },
  mounted() {
    this.fields = [
      { key: "idDoumentacionLegal", label: "ID DOCUMENTO", sortable: true },
      { key: "documentacion", label: "DOCUMENTO", sortable: true },
      "ACCIONES",
    ];
  },
  methods: {
    agregar() {
      this.documento = {
        idDoumentacionLegal: null,
        documentacion: null,
        rutaDocumentacion: null,
        tipoDocumentoLegalDTO: null,
        imagenBase64: null,
        registro: null,
      };
      this.tituloModal = "Agregar Documento";
      this.show = true;
    },
    changeArchivo(e) {
      const file = e.target.files[0];
      if (file.name.includes(".pdf")) {
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64String = reader.result
            .replace("data:", "")
            .replace(/^.+,/, "");
          this.documento.imagenBase64 = base64String;
          this.loaderArchivo = false;
        };
        reader.readAsDataURL(file);
      } else {
        this.$swal.fire({
          icon: "info",
          title: "Aviso",
          text: "Los archivos deben ser tipo pdf",
        });
        e.target.value = "";
        return false;
      }
    },
    cerrarModal() {
      this.show = false;
    },
    cerrarModalPrevia() {
      this.showVistaPrevia = false;
      this.documento = {
        idDoumentacionLegal: null,
        documentacion: null,
        rutaDocumentacion: null,
        tipoDocumentoLegalDTO: null,
        imagenBase64: null,
        registro: null,
      };
    },
    guardaDocumento() {
      let listaHay = [];
      this.datosTabla.filter((doc) => {
        if (
          doc.documentacion ===
          this.documento.tipoDocumentoLegalDTO.tipoDocumententoLegal +
            "-" +
            this.hoy +
            ".pdf"
        ) {
          listaHay.push(doc.documentacion);
        }
      });
      if (listaHay.length > 0 && this.documento.idDoumentacionLegal === null) {
        this.$swal.fire({
          icon: "info",
          title: "Aviso",
          text: "Ya existe un archivo del presente mes",
        });
        this.loaderAcciones = false;
        return false;
      }
      this.$v.documento.$touch();
      if (this.$v.documento.$anyError) {
        return;
      }
      if (
        !this.$v.documento.$invalid &&
        this.documento.imagenBase64 !== "" &&
        this.documento.imagenBase64 !== null &&
        this.documento.imagenBase64 !== undefined
      ) {
        this.loaderAcciones = true;
        let listaHay = [];
        this.datosTabla.filter((doc) => {
          if (
            doc.documentacion ===
            this.documento.tipoDocumentoLegalDTO.tipoDocumententoLegal +
              "-" +
              this.hoy +
              ".pdf"
          ) {
            listaHay.push(doc.documentacion);
          }
        });
        if (
          listaHay.length > 0 &&
          this.documento.idDoumentacionLegal === null
        ) {
          this.$swal.fire({
            icon: "info",
            title: "Aviso",
            text: "Ya existe un archivo del presente mes",
          });
          this.loaderAcciones = false;
          return false;
        }
        this.documento.documentacion =
          this.documento.tipoDocumentoLegalDTO.tipoDocumententoLegal +
          "-" +
          this.hoy +
          ".pdf";
        this.$http
          .post(
            this.$api + "portalautoservicio/guardarDocumentosLegales",
            this.documento
          )
          .then((response) => {
            if (response.data.data) {
              this.show = false;
              this.obtenerDocumentosLegales();
              this.$swal.fire({
                icon: "info",
                title: "Aviso",
                text: "Se subio el archivo correctamente ",
              });
              this.documento = {
                idDoumentacionLegal: null,
                documentacion: null,
                rutaDocumentacion: null,
                tipoDocumentoLegalDTO: null,
                imagenBase64: null,
                registro: null,
              };
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Aviso",
                text: "Ocurrio un error",
              });
            }
          })
          .catch(() => {
            this.$swal.fire({
              icon: "error",
              title: "Aviso",
              text: "Ocurrio un error",
            });
          })
          .finally(() => {
            this.loaderAcciones = false;
          });
      }
    },
    obtenerTipoDocumentosLegales() {
      const params = {
        idModulo: 1,
      };
      this.$http
        .post(
          this.$api + "portalautoservicio/catalogo/tipoDocumentosLegal",
          params
        )
        .then((respuesta) => {
          if (respuesta.data.data) {
            this.listaTipoDocumentos = respuesta.data.data;
          }
        });
    },
    obtenerDocumentosLegales() {
      this.loader = true;
      this.$http
        .post(
          this.$api + "portalautoservicio/obtener/documentosLegalesV2",
          this.filtro
        )
        .then((respuesta) => {
          if (respuesta.data.data) {
            this.datosTabla = respuesta.data.data;
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },
    vistaPrevia(item) {
      this.showVistaPrevia = true;
      this.base64Archivo = item.imagenBase64;
    },
    modificar(item) {
      this.documento = JSON.parse(JSON.stringify(item));
      this.tituloModal = "Modificar";
      this.show = true;
    },
    activarDesactivarMotivo(item) {
      const mensaje = item.registro
        ? "¿Está seguro de desactivar el documento legal?"
        : "¿Está seguro de activar el documento legal?";
      this.$swal({
        icon: "warning",
        text: mensaje,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if (aceptar.value) {
          const parametros = {
            idDoumentacionLegal: item.idDoumentacionLegal,
          };
          this.$http
            .post(
              this.$api +
                "portalautoservicio/desctivarActivar/detalleDocumentoLegal",
              parametros
            )
            .then((respuesta) => {
              if (respuesta.data.data) {
                item.registro = !item.registro;
                this.$swal.fire({
                  icon: "info",
                  title: "Aviso",
                  text: "El documento legal se actualizó correctamente",
                });
              }
            });
        }
      });
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.documento[name];
      return $dirty ? !$error : null;
    },
    selectClass(attribute) {
      let state = this.validateState(attribute);
      if (state) {
        return "border rounded-lg border-success";
      } else if (state === false) {
        return "border rounded-lg border-danger";
      } else {
        return "";
      }
    },
  },
};
</script>

<style scoped>
.selectedTab {
  color: #00254c;
  font-weight: 600;
}

.tabPortal {
  color: rgb(164, 164, 164) !important;
}

.btn-file {
  position: relative;
  overflow: hidden;
}
.btn-file input[type="file"] {
  position: absolute;
  top: 0;
  right: 0;
  min-width: 100%;
  min-height: 100%;
  font-size: 100px;
  text-align: right;
  filter: alpha(opacity=0);
  opacity: 0;
  outline: none;
  background: white;
  cursor: inherit;
  display: block;
}
.card-body {
  padding: 0.25rem !important;
}
.card-footer {
  font-size: 12px;
  font-weight: bold;
}
.bCardLocal{
  margin: 1%;
  padding: 0.5% 1% 0.5% 1%;
  min-height: 90vh;
  border-radius: 20px;
}
.barras {
    border-width: 1px;
    border-style: solid;
    border-color: #C6E9EE;
    background: #ffffff;
    margin-top: 20px;
    padding-right: 1%;
    padding-left: 1%;
    border-radius: 50px;
    text-align: left;
    align-items: center;
}
.botonesAzulFuerteRedondo{
  height: 2em;
  width: 2em;
  border-radius: 50px;
  background-color: #1B81AF;
  border: 1px solid #1B81AF;
}

.botonesAzulFuerteRedondo:hover{
  height: 2em;
  width: 2em;
  border-radius: 50px;
  background-color: #69b8dd;
  border: 1px solid #69b8dd;
}
.btn_busqueda{
  height: 1.7em;
  width: 1.7em;
}
</style>
